export const HeaderValues = {
  NoCache: 'no-cache',
  PartnerCenterClient: 'Partner Center Web',
  PartnerCenterSupportClient: 'True',
  ApplicationJson: 'application/json',
};

export const HeaderNames = {
  PartnerCenterClient: 'MS-PartnerCenter-Client',
  MSRequestId: 'MS-RequestId',
  MSCorrelationId: 'MS-CorrelationId',
  CorrelationId: 'X-Correlation-Id',
  IsCorpNet: 'IsCorpNet',
  Locale: 'X-Locale',
  SupportLocale: 'X-Support-Locale',
  CacheControl: 'Cache-Control',
  Pragma: 'Pragma',
  PartnerCenterSupportClient: 'MS-PartnerCenter-SupportClient',
  Flights: 'Flights',
  IncludeOrganizationRequests: 'IncludeOrganizationRequests',
  Authorization: 'Authorization',
  Accept: 'Accept',
  SessionId: 'X-Session-Id',
  AccessControlAllowOrigin: 'Access-Control-Allow-Origin',
};
